// File: src/components/mixer/Color Mixer UI Components/MixerAvatarRow.jsx
import React from 'react';
import { FaThumbsUp } from 'react-icons/fa';

const styles = {
  container: {
    textAlign: 'center',
    fontFamily: "'Open Sans', sans-serif",
    color: '#888',
    maxWidth: 500,
    margin: '0 auto',
  },
  profilesContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    position: 'relative',
    marginTop: '2rem',
  },
  profileColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '0 0 auto',
  },
  profilePic: {
    width: 140,
    height: 140,
    borderRadius: '50%',
    border: '5px solid #fff',
    backgroundColor: '#ccc',
    objectFit: 'cover',
  },
  profileLeft: { zIndex: 2, marginRight: '-10px' },
  profileRight: { zIndex: 1, marginLeft: '-10px' },
  thumbIcon: {
    position: 'absolute',
    top: '70px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    borderRadius: '50%',
    width: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#3b82f6',
    zIndex: 10000,
    fontSize: '0.85rem',
  },
  namePill: {
    backgroundColor: '#F9F9F9',
    borderRadius: 20,
    padding: '4px 16px',
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '0.8rem',
    marginTop: '0.75rem',
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginRight: 6,
  },
  heading: {
    fontSize: '1.2rem',
    marginTop: '1.75rem',
    color: '#888',
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },
  boldName: {
    color: '#000',
    fontWeight: 700,
  },
  subheading: {
    fontSize: '0.75rem',
    marginTop: '0.5rem',
    color: '#9ca3af',
    maxWidth: 300,
    marginLeft: 'auto',
    marginRight: 'auto',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
};

// Format "First Last" → "First L."
function formatName(name = '') {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '';
  if (parts.length === 1) return parts[0];
  const first = parts[0];
  const lastInitial = parts[parts.length - 1][0]?.toUpperCase();
  return lastInitial ? `${first} ${lastInitial}.` : first;
}

export default function MixerAvatarRow({
  yourName = '',
  partnerName = '',
  yourPic,
  partnerPic,
  yourColor = '#3b82f6',
  partnerColor = '#ef4444',
}) {
  const yourFormatted = formatName(yourName);
  const partnerFormatted = formatName(partnerName);

  return (
    <div style={styles.container}>
      <div style={styles.profilesContainer}>
        {/* Your profile + tag */}
        <div style={{ ...styles.profileColumn, ...styles.profileLeft }}>
          <img
            src={(yourPic && String(yourPic).trim()) || '/default-avatar.png'}
            onError={(e) => { e.currentTarget.src = '/default-avatar.png'; }}
            alt={`${yourFormatted || 'You'} profile`}
            style={styles.profilePic}
          />
          <span style={styles.namePill}>
            <span style={{ ...styles.dot, backgroundColor: yourColor }} />
            {yourFormatted}
          </span>
        </div>

        {/* Partner profile + tag */}
        <div style={{ ...styles.profileColumn, ...styles.profileRight }}>
          <img
            src={(partnerPic && String(partnerPic).trim()) || '/default-avatar.png'}
            onError={(e) => { e.currentTarget.src = '/default-avatar.png'; }}
            alt={`${partnerFormatted || 'Partner'} profile`}
            style={styles.profilePic}
          />
          <span style={styles.namePill}>
            <span style={{ ...styles.dot, backgroundColor: partnerColor }} />
            {partnerFormatted}
          </span>
        </div>

        <div style={styles.thumbIcon}>
          <FaThumbsUp />
        </div>
      </div>

      <div style={styles.heading}>
        You & <span style={styles.boldName}>{partnerFormatted}</span> are connected
      </div>

      <div style={styles.subheading}>
        Wait for the duration of the timer to end and at
        <br />
        zero you will automatically be taken to the icebreaker screen.
      </div>
    </div>
  );
}
